import { render } from "./NonEC.vue?vue&type=template&id=5295d825"
import script from "./NonEC.vue?vue&type=script&lang=js"
export * from "./NonEC.vue?vue&type=script&lang=js"

import "./NonEC.vue?vue&type=style&index=0&id=5295d825&lang=css"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__